import React, { useEffect, useState } from "react";
import GridTable from "cvmgmt-cube-grid-table";
import { getEnv } from "../../Constants/env";
import PanelComponent from "../PanelComponent/PanelComponent";
import { useSelector } from "react-redux";
import ManageDataDomain from "./ManageDataDomain";
import * as style from "./DataDomain.module.scss";
import { useLocation } from "react-router-dom";
import Button from "../Common/CprimeButton";
import { useIdToken } from "../../hooks/useAuthSession";

interface DataDomainTableProps {
  appId?: number;
  isCreateDataDomain?: boolean;
  setIsCreateDataDomain?: any;
  getApplicationDetails?: any;
  isEditable?: boolean;
}

const DataDomainTable: React.FC<DataDomainTableProps> = ({
  appId,
  isCreateDataDomain,
  setIsCreateDataDomain,
  getApplicationDetails = () => null,
  isEditable = false,
}) => {
  const location = useLocation();
  const idToken = useIdToken();
  const isAllDomainsPage = location.pathname === "/all-domains";

  const [refresh, setRefresh] = useState(0);
  const [openPanel, setOpenPanel] = useState<boolean>(
    isCreateDataDomain ?? false,
  );
  const [editForm, setEditForm] = useState<any>(null);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  const { env } = useSelector((state: any) => state?.createApplication);
  const scssClass = style as any;

  useEffect(() => {
    if (isCreateDataDomain) setOpenPanel(true);
  }, [isCreateDataDomain]);

  const getApiUrl = () => {
    if (isAllDomainsPage) {
      return `${getEnv()?.baseURL}/datasetup/domain-list?env=${env}`;
    }
    return `${getEnv()?.baseURL}/datasetup/domain-list?appId=${appId}&env=${env}`;
  };

  const handleCreateDomain = () => {
    setOpenPanel(true);
    setEditForm(null);
    setIsCreating(true);
    setIsCreateDataDomain?.(true);
  };

  return (
    <div
      style={
        isAllDomainsPage
          ? { margin: "2rem 2rem 0rem" }
          : { margin: "0", width: "100%" }
      }
    >
      {isAllDomainsPage && (
        <div className={scssClass.header}>
          <div className={scssClass.title}>Domain Management</div>
          <Button variant="tertiary" size="medium" onClick={handleCreateDomain}>
            Create Domain
          </Button>
        </div>
      )}
      {idToken && (
        <GridTable
          style={{
            height: isAllDomainsPage
              ? `calc(100vh - ${!isEditable ? 30.2 : 28}rem)`
              : `calc(100vh - ${!isEditable ? 36.2 : 34}rem)`,
          }}
          refresh={refresh}
          customPayload={true}
          isCustomizeColumns={false}
          title={isAllDomainsPage ? "All Domains" : "Domain Details"}
          apiConfig={{
            url: getApiUrl(),
            data: {
              sortingFilter: {
                filter: [],
                sort: [],
                page: {
                  limit: 25,
                  offset: 0,
                },
              },
            },
            headers: {
              Authorization: idToken,
              "x-api-key": "sasa",
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            documentUrl: "",
          }}
          onRowClick={(_, row: any) => {}}
          cellActions={[
            {
              event: "Edit",
              disabled: !isEditable,
              callback: (_event, data) => {
                const row = data?.row;
                setOpenPanel(true);
                setEditForm(row?.original);
                setIsCreating(false);
              },
            },
          ]}
          isPagination={true}
          showLoader={false}
        />
      )}
      {openPanel && (
        <PanelComponent
          open={openPanel}
          title={`${(isAllDomainsPage ? isCreating : isCreateDataDomain) ? "Create" : "Edit"} Domain`}
          isEdit={false}
          onClose={() => {
            setOpenPanel(false);
            setIsCreateDataDomain?.(false);
            setEditForm(null);
            setIsCreating(false);
          }}
          getApplicationDetails={getApplicationDetails}
          BodyComponent={
            <ManageDataDomain
              appId={appId ?? 0}
              isEdit={!(isAllDomainsPage ? isCreating : isCreateDataDomain)}
              formData={editForm}
              onClose={() => {
                setOpenPanel(false);
                setIsCreateDataDomain?.(false);
                setEditForm(null);
                setIsCreating(false);
              }}
              incrementTableRefresh={() => setRefresh((prev) => prev + 1)}
            />
          }
          tabValue={10}
        />
      )}
    </div>
  );
};

export default DataDomainTable;
